import { useEffect, useState } from 'react'
import { Refresh } from '../icons'
import { registerServiceWorker, type SwUpdateController } from '../lib/sw-register'

/**
 * Bottom-right banner that appears once when a new app version is ready.
 * Click "Aggiorna" → the new service worker takes control and the page
 * reloads automatically. Until clicked, the user keeps running the old
 * version (avoids interrupting an in-flight action).
 */
export function UpdateAvailable() {
  const [ctrl, setCtrl] = useState<SwUpdateController | null>(null)

  useEffect(() => {
    registerServiceWorker((c) => setCtrl(c))
  }, [])

  if (!ctrl) return null

  return (
    <div className="update-available" role="status" aria-live="polite">
      <div className="update-available__text">
        <strong>Aggiornamento disponibile</strong>
        <span>Una nuova versione di ACT è pronta.</span>
      </div>
      <button
        type="button"
        className="btn btn--primary"
        onClick={() => ctrl.applyUpdate()}
      >
        <Refresh />
        <span>Aggiorna</span>
      </button>
    </div>
  )
}
